/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstCustomerCenterUpdateBase } from './MstCustomerCenterUpdateBase';
import {
    MstCustomerCenterUpdateBaseFromJSON,
    MstCustomerCenterUpdateBaseFromJSONTyped,
    MstCustomerCenterUpdateBaseToJSON,
    MstCustomerCenterUpdateBaseToJSONTyped,
} from './MstCustomerCenterUpdateBase';

/**
 * 
 * @export
 * @interface MstCustomerCenterUpdate
 */
export interface MstCustomerCenterUpdate {
    /**
     * 
     * @type {Array<MstCustomerCenterUpdateBase>}
     * @memberof MstCustomerCenterUpdate
     */
    body: Array<MstCustomerCenterUpdateBase>;
}

/**
 * Check if a given object implements the MstCustomerCenterUpdate interface.
 */
export function instanceOfMstCustomerCenterUpdate(value: object): value is MstCustomerCenterUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MstCustomerCenterUpdateFromJSON(json: any): MstCustomerCenterUpdate {
    return MstCustomerCenterUpdateFromJSONTyped(json, false);
}

export function MstCustomerCenterUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCustomerCenterUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(MstCustomerCenterUpdateBaseFromJSON)),
    };
}

export function MstCustomerCenterUpdateToJSON(json: any): MstCustomerCenterUpdate {
    return MstCustomerCenterUpdateToJSONTyped(json, false);
}

export function MstCustomerCenterUpdateToJSONTyped(value?: MstCustomerCenterUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(MstCustomerCenterUpdateBaseToJSON)),
    };
}

